class CopyToClipboard {
    constructor(element, options) {
        this._element = element;
        this._options = options;
        this._targetElement = document.querySelector(this._options.copyTarget);
        this._triggerElements = Array.from(
            document.querySelectorAll(this._options.copyTriggers)
        );
        this._messageElement =
            document.getElementById("copy-message") ||
            document.createElement("p");

        this._init();
    }

    _init() {
        this._triggerElements.forEach(trigger =>
            trigger.addEventListener("click", e => this._onClick(e))
        );
    }

    _onClick(e) {
        e.preventDefault();
        this._selectTarget();

        try {
            document.execCommand("copy")
                ? this._displayMessage(this._options.successMessage)
                : this._displayMessage("Er ging iets mis bij het kopiëren");
        } catch (error) {
            alert(`Er ging iets mis bij het kopiëren: ${error}`);
        }
    }

    _displayMessage(text) {
        this._messageElement.id = "copy-message";
        this._messageElement.classList.add("animation--fade-in");
        this._messageElement.textContent = text;
        this._targetElement.parentNode.insertBefore(
            this._messageElement,
            this._targetElement.nextSibling
        );
    }

    _selectTarget() {
        if (document.body.createTextRange) {
            // ms
            const range = document.body.createTextRange();
            range.moveToElementText(this._targetElement);
            range.select();
        } else if (window.getSelection) {
            // moz, opera, webkit
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(this._targetElement);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}
